import { Component, OnDestroy, OnInit } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, messagesStateGetMessageResetFlag } from "src/app/store/reducers";

import { SnackbarService } from "../../services/snackbar/snackbar.service";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

@Component({
  selector: "app-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
  animations: [
    trigger('state', [
      transition(':enter', [
        style({ bottom: '-100px', transform: 'scale(0.3)' }),
        animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({
          transform: 'scale(1)',
          opacity: 1,
          bottom: '20px'
        }))
      ]),
      transition(':leave', [
        animate('150ms cubic-bezier(0.4, 0, 1, 1)', style({
          transform: 'scale(0.3)',
          opacity: 0,
          bottom: '-100px'
        }))
      ])
    ])
  ]
})
export class SnackbarComponent implements OnInit, OnDestroy {
  show: boolean;
  message: string;
  type: string = SnackbarType.DEFAULT;

  snackbarSubscription: Subscription;

  snackbarType = SnackbarType;
  timer: number;

  //Reset Message
  resetMessage$: Observable<boolean>;
  resetMessageSub: Subscription;
  resetMessage: boolean;

  constructor(
    private snackbarService: SnackbarService,
    private store: Store<AppState>
  ) {
    this.resetMessage$ = this.store.pipe(select(messagesStateGetMessageResetFlag))
  }

  ngOnInit(): void {
    this.setResetMessageSubscription();
    this.setSnackbarSubscription();
  }

  setResetMessageSubscription() {
    this.resetMessageSub = this.resetMessage$.subscribe((resetMessage) => {
      this.resetMessage = resetMessage;
    });
  }

  setSnackbarSubscription() {
    this.snackbarSubscription = this.snackbarService.snackbarState.subscribe(
      (state) => {
        if (this.resetMessage) {
          return;
        }

        clearTimeout(this.timer);

        const { show, message, type } = state;
        this.type = type ? type : SnackbarType.DEFAULT;
        this.message = message;
        this.show = show;

        if (type !== SnackbarType.ERROR) {
          this.timer = window.setTimeout(() => {
            this.show = false;
          }, 3000);
        }
      }
    );
  }

  closeSnackbar() {
    this.snackbarService.close();
  }

  ngOnDestroy() {
    this.snackbarSubscription.unsubscribe();
    this.resetMessageSub.unsubscribe();
  }
}
